$mol_view_tree2_to_js_test_ex_left_chaining_foo $mol_object
	a <= b <= c? <= d? 0
